import { useQuery } from '@tanstack/react-query'
import { fetchServerTime } from '@api/common/api.js'

export const useTimeQuery = (body = {}) => {
  return useQuery({
    queryKey: ['server-time', body],
    queryFn: () => fetchServerTime(body),
    staleTime: Infinity,
    gcTime: Infinity
  })
}